import { Text, HStack, Icon, VStack, BoxProps } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { handleResponseLanguage } from '../../../../../../../../../i18n';
import { Warning } from '../../../../../../../../../types/Quotes';
import GrayTextBox from '../../../../../../../../company-scan/components/GrayTextBox';

interface Props {
  benefits: Warning[];
  withTitle?: boolean;
}

const OfferBenefits: React.FC<Props & BoxProps> = ({
  benefits,
  withTitle = true,
  ...props
}) => {
  const { t } = useTranslation();
  const disableColumns =
    benefits.some(
      ({ description }) => handleResponseLanguage(description).length > 45,
    ) || benefits.length === 1;

  return (
    <GrayTextBox
      title={withTitle ? t('BENEFITS') : undefined}
      flexDir="row"
      flexWrap="wrap"
      {...props}
    >
      <VStack spacing="1">
        {benefits.map((benefit, index) => (
          <HStack
            key={index}
            color="gray.700"
            minW={{ base: 'auto', laptop: '60' }}
            w={disableColumns ? '100%' : '50%'}
            align="flex-start"
          >
            <Icon name="GeneralActionsAdd" boxSize={4} />
            <Text
              lineHeight="1"
              textStyle="smallBody"
              dangerouslySetInnerHTML={{
                __html: handleResponseLanguage(benefit.description),
              }}
            />
          </HStack>
        ))}
      </VStack>
    </GrayTextBox>
  );
};

export default OfferBenefits;
